module.exports = __webpack_public_path__ + "img/SmartOrg-removebg-preview.c5b419ba.png";